/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { authRequestTokenUpdatePost } from '../fn/auth/auth-request-token-update-post';
import { AuthRequestTokenUpdatePost$Params } from '../fn/auth/auth-request-token-update-post';
import { authTokenPost } from '../fn/auth/auth-token-post';
import { AuthTokenPost$Params } from '../fn/auth/auth-token-post';

@Injectable({ providedIn: 'root' })
export class AuthHttpService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authTokenPost()` */
  static readonly AuthTokenPostPath = '/Auth/token';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authTokenPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  authTokenPost$Response(params?: AuthTokenPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = authTokenPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authTokenPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authTokenPost(params?: AuthTokenPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.authTokenPost$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `authRequestTokenUpdatePost()` */
  static readonly AuthRequestTokenUpdatePostPath = '/Auth/request-token-update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authRequestTokenUpdatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authRequestTokenUpdatePost$Response(
    params?: AuthRequestTokenUpdatePost$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    const obs = authRequestTokenUpdatePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authRequestTokenUpdatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authRequestTokenUpdatePost(params?: AuthRequestTokenUpdatePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.authRequestTokenUpdatePost$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
